<template>
  <div>
    <div class="d-flex align-center">
      <filter-by-date type="date" v-if="planned" small :namespace="namespace" />
      <interventions-filter :namespace="namespace" />
    </div>
    <v-data-table
      dense
      v-resize="onResize"
      :loading="loading"
      fixed-header
      disable-pagination
      disable-sort
      :height="height"
      hide-default-footer
      :headers="headers"
      :items="data"
      :no-data-text="
        error
          ? 'Une erreur est survenue lors de la récupération des données.'
          : 'Aucune intervention répondant aux critères'
      "
      class="elevation-1 secondarybackground striped-table"
    >
      <template v-slot:top>
        <div class="d-flex justify-end">
          <custom-page-selector class="pa-2" :namespace="namespace" />
        </div>
      </template>
      <template v-slot:item.reference="{ item }">
        {{ item.reference }} - {{ item.reference_num }}
      </template>
      <template v-slot:item.event_datetime="{ item }">
        <v-tooltip bottom v-if="item.customer_type_name">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              {{ item | displaySchedule }}
              <span v-if="item.duration">({{ item.duration }})</span>
            </div>
          </template>
          <span>
            {{ item.customer_type_name }}
            <span v-if="item.customer_phone">({{ item.customer_phone }})</span>
          </span>
        </v-tooltip>
        <div v-else>
          {{ item | displaySchedule }}
          <span v-if="item.duration">({{ item.duration }})</span>
        </div>
      </template>
      <template v-slot:item.technician_fullname="{ item }">
        {{ item.technician_fullname }} - {{ item.technician_phone }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CustomPageSelector from '@/components/selects/customPageSelector/index';
import resizable from '@/business/mixins/resizable';
import FilterByDate from '@/components/boilerplate/RightSideBar/FilterByDate';
import {
  POPUP_BOTTOM_HEIGHT,
  POPUP_TOP_HEIGHT,
} from '@/components/dialogs/customDialog.styles';
import {
  INTERVENTIONS_FILTERS_HEIGHT,
  TABS_HEIGHT,
  INTERVENTIONS_TABS_HEIGHT,
} from '@/pages/eDispatch/requestDetails/rightSide/requestsRightSide';
import HISTORY_DATATABLE_FOOTER_HEIGHT from '@/pages/eDispatch/requestDetails/rightSide/historyTab/HistoryDataTable.styles';
import InterventionsFilter from './InterventionsFilter';

const headersInProgress = [
  { text: 'Référence', value: 'reference' },
  { text: "Date de début d'ITV (durée)", value: 'event_datetime' },
  { text: 'Technicien', value: 'technician_fullname' },
  { text: "Nature & libellé de l'intervention", value: 'description' },
  { text: 'Code prestation', value: 'prestation_code' },
];
const headersPlanned = [
  { text: 'Référence', value: 'reference' },
  { text: "Date de planification d'ITV (durée)", value: 'event_datetime' },
  { text: 'Technicien', value: 'technician_fullname' },
  { text: "Nature & libellé de l'intervention", value: 'description' },
  { text: 'Code prestation', value: 'prestation_code' },
];

export default {
  name: 'InterventionsDataTable',
  mixins: [resizable],
  components: {
    CustomPageSelector,
    InterventionsFilter,
    FilterByDate,
  },
  props: {
    namespace: { type: String, required: true },
    planned: { type: Boolean, required: false },
  },
  computed: {
    data() {
      return this.$store.getters[`${this.namespace}/items`];
    },
    loading() {
      return this.$store.getters[`${this.namespace}/isLoadingItems`];
    },
    error() {
      return this.$store.getters[`${this.namespace}/error`];
    },
    headers() {
      return (this.planned ? headersPlanned : headersInProgress).map((item) => {
        return { ...item, align: 'center', class: 'secondarybackground' };
      });
    },
    height() {
      return (
        this.boilerplatePopupHeight -
        TABS_HEIGHT -
        INTERVENTIONS_TABS_HEIGHT -
        INTERVENTIONS_FILTERS_HEIGHT -
        POPUP_TOP_HEIGHT -
        POPUP_BOTTOM_HEIGHT -
        HISTORY_DATATABLE_FOOTER_HEIGHT
      );
    },
  },
  data() {
    return {
      HISTORY_DATATABLE_FOOTER_HEIGHT,
    };
  },
  filters: {
    displaySchedule(item) {
      return item.scheduled_type === 'P' &&
        item.planification === 'Non-Ordonnancée'
        ? `Prévue la semaine du ${item.event_datetime.toLocaleDateString()}`
        : item.event_datetime.toLocaleString();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>
